import { render, unmountComponentAtNode } from './src/react-dom-wrapper';

export {
  /** @deprecated Please use `createRoot` from `react-dom/client` */
  render,
  /** @deprecated */
  unmountComponentAtNode,
} from './src/react-dom-wrapper';

/** @deprecated */
export default {
  /** @deprecated Please use `createRoot` from `react-dom/client` */
  render,
  /** @deprecated */
  unmountComponentAtNode,
};
